import { IconCheck } from '@tabler/icons-react';
import styled, { css } from 'styled-components';

import { LinkButton, PrimaryButton } from 'brand-guidelines/Buttons-styled-components';
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';

import { textDefaults } from './Autocomplete-styled-components';

export const DropdownBody = styled.div`
  display: flex;
  flex-direction: column;

  padding: 12px;

  /* 130px is arbitrarily chosen and may need to be adjusted */
  @container (max-width: 130px) {
    padding: 12px 0;
  }

  background: ${BRAND_COLORS.white};
  border: none;

  width: 100%;

  overscroll-behavior: contain;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: ${BRAND_COLORS.stroke} transparent;
`;

const getLabelStyles = ({ $isLabel }: OptionButtonProps) => {
  if (!$isLabel) {
    return;
  }

  return css`
    padding-left: 4px;
    color: ${BRAND_COLORS.darkStroke};
    cursor: default;
    pointer-events: none;
  `;
};

interface OptionButtonProps {
  $isHovered: boolean;
  $isLabel: boolean;
}

export const OptionButton = styled.button.attrs<OptionButtonProps>({
  type: 'button',
})`
  ${textDefaults}

  width: 100%;
  background: none;
  border: none;
  outline: none;

  padding: 12px;
  border-radius: 4px;

  cursor: pointer;

  word-break: keep-all;

  ${getLabelStyles}

  ${({ $isHovered }) =>
    $isHovered
    && css`
      background: ${BRAND_COLORS.ashGreen};
    `}
`;

export const OptionTitle = styled.p`
  ${textDefaults}
  ${TYPOGRAPHY.CIRCULAR.bold}
`;

export const OptionDescription = styled.p`
  ${textDefaults}
`;

export const CheckboxOptionWrapper = styled(OptionButton)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const DropdownFooter = styled.div`
  display: flex;
  padding: 8px 12px;

  justify-content: flex-end;
  align-items: center;
  gap: 12px;

  border-top: 1px solid ${BRAND_COLORS.stroke};
`;

export const ApplyButton = styled(PrimaryButton)`
  padding: 8px 32px;
`;

export const CancelButton = styled(LinkButton)`
  color: ${BRAND_COLORS.darkGray};
`;

export const OptionContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const OptionCheckIcon = styled(IconCheck)`
  margin-left: 8px;
  flex-shrink: 0;
`;
